module.exports = __webpack_public_path__ + "static/media/mahmut-keygubatli.6af844c4.jpg";